// extracted by mini-css-extract-plugin
module.exports = {"label":"select_label__tQuvE","image":"select_image__1bs9O"};